import { configureStore } from '@reduxjs/toolkit';
import { useDispatch } from 'react-redux';
import testSlice from './slices/testSlice';
import loadingSlice from './slices/loadingSlice';
import authSlice from './slices/authSlice';
import usersSlice from './slices/usersSlice';
import customersSlice from './slices/customersSlice';
import contactsSlice from './slices/contactsSlice';
import messageSlice from './slices/messageSlice';
import preferenceSlice from './slices/preferenceSlice';
import templateSlice from './slices/templateSlice';
import alternateUserSlice from './slices/alternateUserSlice';
import groupSlice from './slices/groupSlice';
import filtersSlice from './slices/filtersSlice';

export const store = configureStore({
  reducer: {
    testSlice,
    loadingSlice,
    authSlice,
    usersSlice,
    customersSlice,
    contactsSlice,
    messageSlice,
    preferenceSlice,
    templateSlice,
    alternateUserSlice,
    groupSlice,
    filtersSlice
  },
});

export const useAppDispatch = () => useDispatch();
